var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0332 12.352C28.8418 11.6747 28.4344 11.0784 27.873 10.6539C27.3116 10.2293 26.6269 9.99974 25.9231 10H21.6154C20.1364 10 18.8872 10.9951 18.5052 12.352M29.0332 12.352C29.1122 12.6306 29.1538 12.9264 29.1538 13.2308C29.1538 13.5164 29.0404 13.7903 28.8384 13.9923C28.6365 14.1942 28.3625 14.3077 28.0769 14.3077H19.4615C19.1759 14.3077 18.902 14.1942 18.7 13.9923C18.4981 13.7903 18.3846 13.5164 18.3846 13.2308C18.3846 12.9264 18.4277 12.6306 18.5052 12.352M29.0332 12.352C29.9608 12.4224 30.8827 12.5099 31.8002 12.6162C33.3797 12.8 34.5385 14.1627 34.5385 15.7536V34.7692C34.5385 35.6261 34.1981 36.4478 33.5922 37.0537C32.9863 37.6596 32.1645 38 31.3077 38H16.2308C15.3739 38 14.5522 37.6596 13.9463 37.0537C13.3404 36.4478 13 35.6261 13 34.7692V15.7536C13 14.1627 14.1573 12.8 15.7383 12.6162C16.6587 12.5096 17.5812 12.4215 18.5052 12.352",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdDocument);
export default __webpack_public_path__ + "static/media/sd-document.8128b5a6b08a27d11b9d4986bccda39e.svg";
export { ForwardRef as ReactComponent };